// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11aqU","textarea":"styles_textarea__1UTyo"};